import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import IconRobot from 'assets/images/robot.png';

import { PATHS } from 'routes';
import { useTitle } from 'hooks';
import { IconLogo } from 'assets';
import { BlueButton } from 'components/shared';
import { Main, Container } from 'components/layouts';

const Wrapper = styled.div`
  max-width: 48.3125rem;
  margin: 0 auto;
  padding-top: 6rem;

  @media (max-width: 48.25rem) {
    padding: 2rem 1rem;
  }

  & .container {
    & ins {
      color: #777;
      text-decoration: none;
    }

    & .row-1 {
      & svg {
        width: 9.375rem;
      }

      @media (min-width: 48.3125rem) {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      & .row-1__col-1 {
        @media (min-width: 48.3125rem) {
          width: 50%;
        }

        & p:nth-child(1) {
          padding-bottom: 0.8rem;
        }
      }

      & .row-1__col-2 {
        display: none;

        @media (min-width: 48.3125rem) {
          display: block;
        }
      }
    }
    & > .row-2 {
      width: 9.375rem;

      @media (max-width: 48.25rem) {
        margin: 1rem 0;
      }
    }
  }
`;

type Pathname = {
  pathname: string;
};

type LocationState = {
  from?: Pathname;
  to?: Pathname;
  title?: string;
  message?: string;
};

type FallbackProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  from?: Pathname; // useful when working with breadcrumbs
  to?: Pathname; // useful when working with breadcrumbs
  title?: string;
  message?: string;
};

function Fallback(props: FallbackProps) {
  useTitle('404');
  const navigate = useNavigate();
  const { state, pathname } = useLocation();

  const { to: pTo, title: pTitle, message: pMsg } = props;
  const { to: sTo, title: sTitle, message: sMsg } = (state as LocationState) || {};
  const to = pTo ?? sTo;
  const msg = pMsg ?? sMsg;
  const title = pTitle ?? sTitle;

  return (
    <Main>
      <Wrapper>
        <Container className="container">
          <div className="row-1">
            <div className="row-1__col-1">
              <IconLogo />
              <p>
                {title ?? (
                  <>
                    <b>404.</b>
                    <ins> That&apos;s an error.</ins>
                  </>
                )}
              </p>
              <p>
                {msg ?? (
                  <>
                    The requested URL &ldquo;<code>{pathname}</code>&rdquo; was not found on this server.<ins> That’s all we know.</ins>
                  </>
                )}
              </p>
            </div>
            <div className="row-1__col-2">
              <img src={IconRobot} alt="" />
            </div>
          </div>
          <div className="row-2">
            <BlueButton
              shape="radius"
              onClick={() => {
                navigate(to ?? PATHS.home, { replace: true });
              }}
            >
              Go home
            </BlueButton>
          </div>
        </Container>
      </Wrapper>
    </Main>
  );
}

export { Fallback };
